export default class FnEditorLogger {
    constructor(enabled) {
        this.enabled = enabled;
    }
    log(...data) {
        if (this.enabled) {
            console.log(...data);
        }
    }
}
